"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowVersionStatus = void 0;
var FlowVersionStatus;
(function (FlowVersionStatus) {
    FlowVersionStatus["DRAFT"] = "DRAFT";
    FlowVersionStatus["PUBLISHED"] = "PUBLISHED";
    FlowVersionStatus["INACTIVE"] = "INACTIVE";
})(FlowVersionStatus = exports.FlowVersionStatus || (exports.FlowVersionStatus = {}));
//# sourceMappingURL=Flows.js.map